import {
    Heading,
    HStack,
    VStack,
    Text,
    Wrap,
    WrapItem,
    Divider,
} from '@chakra-ui/react'
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'

const Contributors = () => {
    return (
        <HStack alignItems="flex-start" width="100%">
            <VStack
                spacing="5"
                background="white"
                padding="24px"
                borderRadius="24px"
                minWidth={'container.md'}
                width="100%"
            >
                <Heading textAlign="center" color={'twitter.800'}>
                    Contributors
                </Heading>
                <Text
                    maxW={'container.sm'}
                    textAlign="left"
                    fontSize={'sm'}
                    fontStyle="italic"
                    color="gray.500"
                >
                    Qoroyo is a linguistic and hermeneutical tool that
                    facilitates multilingual presentation and annotation of
                    textual data and the application of computational analytical
                    methods. It is developed by a team of volunteers and
                    contributors who are passionate about language and text
                    analysis.
                </Text>
                <VStack spacing={10} style={{ marginTop: '4rem' }} pb="5">
                    <Wrap>
                        <WrapItem>
                            <Avatar
                                name="Yusuf Çelik"
                                src="/profiles/yusuf.jpeg"
                                size="xl"
                                className="animated-bg-2"
                            />
                            <Text
                                ml="5"
                                maxW={'container.sm'}
                                display="flex"
                                alignItems={'center'}
                                height="100%"
                            >
                                Dr. Yusuf Çelik, assistant professor Digital
                                Humanites & Islam at the Vrije Universiteit, is
                                the co-project lead and architect of Qoroyo.
                            </Text>
                        </WrapItem>
                    </Wrap>
                    <Divider />

                    <Wrap>
                        <WrapItem>
                            <Avatar
                                name="Willem van Peursen"
                                src="/profiles/willem.webp"
                                size="xl"
                                className="animated-bg-2"
                            />
                            <Text
                                ml="5"
                                maxW={'container.sm'}
                                display="flex"
                                alignItems={'center'}
                                height="100%"
                            >
                                Prof. Dr. Willem van Peursen is a professor of
                                Old Testament Studies at the Vrije Universiteit
                                and the co-project lead of Qoroyo.
                            </Text>
                        </WrapItem>
                    </Wrap>
                    <Divider />
                    <Wrap>
                        <WrapItem>
                            <Avatar
                                name="Yusuf Çelik"
                                src="/profiles/constantijn.jpg"
                                size="xl"
                                className="animated-bg-2"
                            />
                            <Text
                                ml="5"
                                maxW={'container.sm'}
                                display="flex"
                                alignItems={'center'}
                                height="100%"
                            >
                                Constantijn Sikkel is research staff at the Eep
                                Talstra Centre for Bible and Computer and
                                responsible for the backend API of Qoroyo.
                            </Text>
                        </WrapItem>
                    </Wrap>
                    <Divider />
                    <Wrap>
                        <WrapItem>
                            <Avatar
                                name="Matthias Hadi Benabdellah"
                                src="/profiles/matthias.jpg"
                                size="xl"
                                className="animated-bg-2"
                            />
                            <Text
                                ml="5"
                                maxW={'container.sm'}
                                display="flex"
                                alignItems={'center'}
                                height="100%"
                            >
                                Matthias Hadi Benabdellah is a research
                                assistant and PhD candidate at the Vrije
                                Universiteit.
                            </Text>
                        </WrapItem>
                    </Wrap>
                    <Divider />
                    <Wrap>
                        <WrapItem>
                            <Avatar
                                name="Gegham Bdoyan"
                                src="/profiles/gegham.jpeg"
                                size="xl"
                                className="animated-bg-2"
                            />
                            <Text
                                ml="5"
                                maxW={'container.sm'}
                                display="flex"
                                alignItems={'center'}
                                height="100%"
                            >
                                Gegham Bedoyan is a research assistant and PhD
                                candidate at the Vrije Universiteit.
                            </Text>
                        </WrapItem>
                    </Wrap>
                    <Divider />
                    <Wrap>
                        <WrapItem>
                            <Avatar
                                name="Logan Copley"
                                src="/profiles/logan.jpg"
                                size="xl"
                                className="animated-bg-2"
                            />
                            <Text
                                ml="5"
                                maxW={'container.sm'}
                                display="flex"
                                alignItems={'center'}
                                height="100%"
                            >
                                Logan Copley is a research assistant and PhD
                                candidate at the Vrije Universiteit.
                            </Text>
                        </WrapItem>
                    </Wrap>
                    <Divider />
                    <Wrap>
                        <WrapItem>
                            <Avatar
                                name="Logan Copley"
                                src="/profiles/umut.jpg"
                                size="xl"
                                className="animated-bg-2"
                            />
                            <Text
                                ml="5"
                                maxW={'container.sm'}
                                minW={'container.sm'}
                                display="flex"
                                alignItems={'center'}
                                height="100%"
                            >
                                Umut Var is a postdoctoral researcher at the
                                Vrije Universiteit Amsterdam.
                            </Text>
                        </WrapItem>
                    </Wrap>
                    <Divider />
                    <Heading textAlign="center" color={'twitter.800'}>
                        Advisory board
                    </Heading>
                    <Text
                        maxW={'container.sm'}
                        textAlign="left"
                        fontSize={'sm'}
                        fontStyle="italic"
                        color="gray.500"
                    >
                        Details will follow soon...
                    </Text>
                </VStack>
            </VStack>
        </HStack>
    )
}

export default Contributors
